import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMemo } from 'react';

const withRouter = (Component) => {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const history = useMemo(
      () => ({
        push: (to, options) => navigate(to, options),
        replace: (to, options) => navigate(to, { ...options, replace: true }),
        goBack: () => navigate(-1),
      }),
      [navigate]
    );

    const match = useMemo(() => ({ params }), [params]);

    return (
      <Component
        {...props}
        location={location}
        history={history}
        navigate={navigate}
        match={match}
      />
    );
  }

  ComponentWithRouterProp.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;

  return ComponentWithRouterProp;
};

export default withRouter;
